<template>
  <div class="nav sidebar-list flex-column">
    <template v-for="item in links">
      <template v-if="item.isExpendable && !item.hidden">
        <b-nav-toggle class="sidebar-link" :target="item.expendableId">
          <template #default="{expanded}">
            <b-nav-item :class="{'active': expanded}">
              <i :class="item.icon + ' mr-2'"></i>
              {{item.title}}
              <caret-down-icon v-if="expanded"></caret-down-icon>
              <caret-left-icon v-else></caret-left-icon>
            </b-nav-item>
          </template>
        </b-nav-toggle>
        <b-collapse :id="item.expendableId" accordion="sidebar-accordion">
          <b-nav-item
            v-for="underItem in underlinks[item.underlinksIndex]"
            :key="underItem.route"
            class="sidebar-link sidebar-underlink"
            :to="underItem.route">
            {{underItem.title}}
          </b-nav-item>
        </b-collapse>
      </template>
      <template v-else-if="!item.hidden">
        <b-nav-toggle target="sidebar-reset">
          <!-- @click="$emit pour désactiver le menu en mobile en changeant de page -->
          <b-nav-item
            @click="$emit('toggle-burger')"
            :class="'sidebar-link '+ activeItem(item)"
            :to="item.route">
            <i :class="item.icon + ' mr-2 ' + activeItem(item)"></i>
            <div :class="activeItem(item)" style="text-align: left;">{{ item.title }}</div>
          </b-nav-item>
        </b-nav-toggle>
        <b-collapse id="sidebar-reset" accordion="sidebar-accordion"></b-collapse>
      </template>
    </template>
    <!-- rapport de bug -->
    <b-nav-item
      v-show="activeReportBug"
      @click="$emit('showReportBugModal')"
      :class="'sidebar-link '">
      <i :class="'ph-bug mr-2 '"></i>
      <div  style="text-align: left;">{{ $t('Report.a.bug') }}</div>
    </b-nav-item>
  </div>
</template>

<script>

export default {
  name: 'SideMenu',

  props: {
    links: {type: Array},
    underlinks: {type: Array},
    activeReportBug: {type: Boolean}
  },

  computed: {
    activeItem () {
      let domaineActive = this.$route.path.split('/')[1]
      return item => item.routesActiveItem ? item.routesActiveItem.filter(routeActiveItem => routeActiveItem.split('/')[1] === domaineActive).length > 0 ? 'activeItem' : '' : ''
    }
  }
}

</script>

<style scoped>

.sidebar-link {
  margin-bottom: 1rem;
}

a {
  text-decoration: none;
  font-family: "SourceSerif4-Regular", "Arial", sans-serif;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: var(--main-border-radius);
}

a i {
  color: var(--main-color);
}

.sidebar-link a {
  color: var(--main-text-color);
  font-size: var(--title-level-two-font-size);
  display: flex;
  align-items: center;
  padding: 12px 22px;
  text-align: left;
}

.sidebar-link a:hover {
  background-color: var(--main-grey);
}

.navbar-toggler{
  padding: 0;
  border:0;
  margin-top: 0;
}

.activeItem a {
  background-color: var(--main-white);
}

</style>



// WEBPACK FOOTER //
// src/views/menus/SideMenu.vue